import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react';
import { some } from 'lodash';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ChatView from './chatView/ChatView';
import LoadingOverlay from '../../shared/components/LoadingOverlay/LoadingOverlay';
import { selectChatData, selectChatState } from '../selectors/chat.selector';
import ContactList from './contacts/ContactList';
import ContactSearch from './contacts/ContactSearch';
import { CHAT_CONNECTION_STATUS_LABEL, getChatConnectionStatus } from '../../shared/utils/chat-utils';

const Chats = () => {
  const { chatId } = useParams<{chatId?: string}>();
  const history = useHistory();
  const [activeChat, setActiveChat] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const chatState = useSelector(selectChatState);
  const activeChatData = useSelector(selectChatData)(activeChat);
  const { connected, connecting, reconnecting } = chatState ?? {};
  const connectionStatus = getChatConnectionStatus(!!activeChatData?.subscriptionError, connected, connecting, reconnecting);

  useEffect(() => {
    setActiveChat(chatId);
  }, [chatId]);

  const changeChatIdHandler = (chatChannel) => {
    setActiveChat(chatChannel);
    history.push(`/chat/${chatChannel}`);
  };

  const handleQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <CRow>
      <CCol lg='12'>
        <div id="chat-page">
          <CRow>
            <CCol lg="12">
              <CCard className="glympser-container--roundedWithShadow overflow-hidden">
                <CCardHeader className='glympser-roundedTop glympser-bottomBorder chat-header-grid' style={{ padding: 0 }}>
                  <div className={`chat-header-left ${activeChat ? 'hide' : ''}`} style={{ borderRight: '1px solid #d8dbe0' }}>
                    <ContactSearch
                      searchQuery={searchQuery}
                      onQueryChange={handleQueryChange}
                    />
                  </div>
                  <div className={`chat-header-right ${activeChat && activeChatData?.chatInfo?.customer ? '' : 'hide'}`} style={{ padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div className="font-weight-bold">{activeChatData?.chatInfo?.customer}</div>
                    <div className={`chat-connection-status chat-connection-status--${connectionStatus}`} style={{ display: 'flex', alignItems: 'center' }}>
                      <span className="chat-connection-status-dot" />
                      {CHAT_CONNECTION_STATUS_LABEL[connectionStatus]}
                    </div>
                  </div>
                </CCardHeader>
                <CCardBody className="p-0">
                  {
                    (chatState?.connecting || some(chatState?.chats, chat => chat?.loading)) ? (
                      <div className="d-flex h-100">
                        <LoadingOverlay />
                      </div>
                    ): null
                  }
                  <div className="chat-card-body-inner-container">
                    <ContactList
                      activeChat={activeChat}
                      onSelectChat={changeChatIdHandler}
                      searchQuery={searchQuery}
                    />
                    <ChatView activeChatId={activeChat}/>
                  </div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
      </CCol>
    </CRow>
  );
};

export default Chats;
